import { render, staticRenderFns } from "./ChatBot.vue?vue&type=template&id=1ed6226b&scoped=true&"
import script from "./ChatBot.vue?vue&type=script&lang=js&"
export * from "./ChatBot.vue?vue&type=script&lang=js&"
import style0 from "./ChatBot.vue?vue&type=style&index=0&id=1ed6226b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ed6226b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
